<template lang="pug" src="./html/PacificPlaceIDD.pug"></template>

<script>

  import Vue from 'vue'
  import PortfolioItemBase from './PortfolioItemBase'

  const PacificPlaceIDDBody = () => import(/* webpackChunkName: "pacific-place-idd" */ './PacificPlaceIDD-Body')

  Vue.component('PacificPlaceIDDBody', PacificPlaceIDDBody)

  export default {
    extends: PortfolioItemBase,
    mounted () {
      this.setBody('PacificPlaceIDDBody')
    }
  }
</script>

<style lang="sass" src="./style/PortfolioItem.sass"></style>

<style scoped>
    .portfolio-item {
        background-color: #FFFFFF;
    }
    .portfolio-item, a {
        color: #3D302C;
    }
    .portfolio-item .logo img {
        max-height: 4em;
        padding-left: 2em;
        padding-right: 2em;
    }
    h1 {
        color: #3D312C;
    }
    .label, h2 {
        color: #AEABA5;
    }
</style>

<style>
    #app.pacific-place-idd #top-header {
        background-color: #92714a;
    }
    #app.pacific-place-idd #load-anim {
        stroke: #92714a;
    }
</style>
